// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2B_ze","label":"SetPasswdForm_label__XmZPB"};